/* Scroll affordance for every horizontal card row (`.scroll-x`).
 *
 * The rows already let the next card peek past the screen edge, which is the textbook hint, and
 * it was not landing: people were not realising the bilona steps and the testimonials could be
 * thumbed sideways at all. A native scrollbar does not rescue it either, because iOS draws no
 * scrollbar until a scroll is already in progress, which is exactly too late to be a hint.
 *
 * So each overflowing row gets a small rail beneath it whose thumb tracks scroll position. It
 * borrows the visual language of the carousel dots already on the homepage, so the gesture reads
 * as the same gesture.
 *
 * Shared on purpose. Three sections use `.scroll-x` and a fourth will, and the lesson from
 * hero.liquid is that a fix living inside one section's stylesheet gets lost the moment anyone
 * copies the section.
 */
(function () {
  // `.scroll-x` is the shared row. `[data-scroll-hint]` is the opt-in for a section that rolled
  // its own scroller before the shared one existed, which process-steps did.
  var rows = document.querySelectorAll('.scroll-x, [data-scroll-hint]');
  if (!rows.length) return;

  rows.forEach(function (row) {
    var rail = null;
    var thumb = null;

    function overflowing() {
      // One pixel of slack: sub-pixel layout rounding reports a 1px overflow on rows that do
      // not actually scroll, which would draw a full-width thumb under a static grid.
      return row.scrollWidth - row.clientWidth > 1;
    }

    function build() {
      if (rail) return;
      rail = document.createElement('div');
      rail.className = 'scroll-rail';
      // Decorative. The row itself is the accessible control, and it is already reachable and
      // scrollable by keyboard, so announcing a second thing here would only add noise.
      rail.setAttribute('aria-hidden', 'true');
      thumb = document.createElement('span');
      thumb.className = 'scroll-rail__thumb';
      rail.appendChild(thumb);
      row.insertAdjacentElement('afterend', rail);
    }

    function update() {
      if (!overflowing()) {
        if (rail) rail.remove();
        rail = null;
        thumb = null;
        return;
      }
      build();
      var max = row.scrollWidth - row.clientWidth;
      var ratio = row.clientWidth / row.scrollWidth;
      var progress = max > 0 ? row.scrollLeft / max : 0;
      thumb.style.width = ratio * 100 + '%';
      // Travel is the leftover track, so the thumb lands flush at either end instead of
      // overshooting by its own width.
      thumb.style.transform = 'translateX(' + progress * (100 / ratio - 100) + '%)';
    }

    update();
    row.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });

    if ('ResizeObserver' in window) {
      // Catches the desktop breakpoint, where some of these rows stop scrolling and become a
      // grid, and a phone turning sideways.
      new ResizeObserver(update).observe(row);
    } else {
      window.addEventListener('resize', update);
    }
  });
})();
